module.exports = __webpack_public_path__ + "img/home-section3-0.81a2048b.png";